import { CMS_Content_Module_AccordionData } from './types';
import { Heading } from '@cue/atoms';
import { Accordion, AccordionEntry } from '@cue/molecules';
import { StyledComponent } from '@cue/theme';
import { CSSObject } from '@emotion/react';
import { useEffect, useState } from 'react';

export const AccordionContentModule: React.FC<
  AccordionContentModuleProps & StyledComponent<AccordionContentModuleCSSOverride>
> = (props) => {
  const { groups } = props;

  const [accordionGroup, setAccordionGroup] = useState<AccordionGroup[]>();

  useEffect(() => {
    setAccordionGroup(
      groups?.map((group) => ({
        label: group.label,
        entries: group?.entries?.map(({ label, content }) => ({
          content: content || '',
          title: label || '',
          key: label,
        })),
      })) || [],
    );
  }, [groups]);

  return (
    <div className="cue-virtual-accordion">
      {accordionGroup?.map(({ label, entries }) => (
        <div key={label}>
          <Heading type="h4">{label}</Heading>
          <Accordion data={entries} />
        </div>
      ))}
    </div>
  );
};

export type AccordionContentModuleCSSOverride = {
  '.cue-virtual-accordion'?: CSSObject;
  '.cue-virtual-fullscreen-content'?: CSSObject;
};

export interface AccordionContentModuleProps extends CMS_Content_Module_AccordionData {
  showTitle?: boolean;
  fallback?: React.ReactNode;
}
/* content: <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>,
          key: '1',
          open: true,
          title: 'Accordion 1' */
export interface AccordionGroup {
  label?: string;
  entries?: AccordionEntry[];
}
